import { render, staticRenderFns } from "./GESPPractice.vue?vue&type=template&id=1c063ce8&scoped=true"
import script from "./GESPPractice.vue?vue&type=script&lang=js"
export * from "./GESPPractice.vue?vue&type=script&lang=js"
import style0 from "./GESPPractice.vue?vue&type=style&index=0&id=1c063ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c063ce8",
  null
  
)

export default component.exports